<template>
  <section id="octadesk-app-login" class="octadesk-app-login">
    <WidgetHeader v-if="active" />

    <Card class="octadesk-login--card">
      <div class="octadesk-content-container">
        <h2
          class="login-form--title"
          v-html="$sanitizeHtml($t('login.title'))"
        />

        <h3
          class="login-form--subtitle"
          v-html="$sanitizeHtml($t('login.subTitle'))"
        />

        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <form
            class="fields-results-container"
            @submit.prevent="handleSubmit(submit)"
          >
            <div class="fields-wrapper">
              <div>
                <label class="login--label">
                  {{ $t('login.fields.name') }}
                </label>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="username"
                  rules="required"
                >
                  <input
                    v-model="chatForm.user.name"
                    type="text"
                    :class="{ 'has-error': errors.length }"
                    class="form-control octadesk-form--input"
                    name="nome"
                  />

                  <span v-if="errors.length" class="text-danger">
                    {{ $t('login.requiredField') }}
                  </span>
                </ValidationProvider>
              </div>

              <div class="space-top-sm">
                <label class="login--label">
                  {{ $t('login.fields.email') }}
                </label>

                <ValidationProvider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <input
                    v-model="chatForm.user.email"
                    type="email"
                    :class="{ 'has-error': errors.length }"
                    class="form-control octadesk-form--input"
                    @change="validUserEmail"
                  />

                  <span v-if="errors.length" class="text-danger">
                    {{ $t('login.requiredField') }}
                  </span>
                </ValidationProvider>
              </div>

              <div v-if="form">
                <div v-for="field in form.fields" :key="field.id">
                  <Field
                    v-model="chatForm.customFields[field.fieldId]"
                    :field="field"
                  ></Field>
                </div>
              </div>
            </div>

            <button
              :style="`background-color: rgb(${settings.bgColorRGB}); color: rgba(${settings.fontColorRGBA});`"
              type="submit"
              class="octadesk-button octadesk-button__login"
            >
              {{ $t('login.fields.buttonStartConversation') }}
            </button>
          </form>
        </ValidationObserver>
      </div>
    </Card>

    <FooterPoweredBy />
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import { ValidationObserver, ValidationProvider } from 'vee-validate'

  import WidgetHeader from '@/app/components/WidgetHeader'

  import FooterPoweredBy from '@/app/components/FooterPoweredBy'

  import Field from './Field'

  import Card from '@/app/components/Card'

  import '../services/rules'

  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
      WidgetHeader,
      Field,
      FooterPoweredBy,
      Card
    },
    data() {
      return {
        chatForm: {
          user: {
            name: '',
            email: ''
          },
          customFields: {}
        }
      }
    },
    computed: {
      ...mapGetters(['settings', 'form', 'user', 'customFields', 'active'])
    },
    created() {
      this.startChooseFluxInterval()
    },
    methods: {
      ...mapActions([
        'login',
        'setUserEmail',
        'startChooseFluxInterval',
        'clearCachedUser'
      ]),
      validUserEmail() {
        if (this.$refs.observer.fields.email.valid) {
          this.setUserEmail(this.chatForm.user.email)
        } else {
          this.setUserEmail('')
        }
      },
      submit() {
        this.clearCachedUser()
        this.login(this.chatForm)
      },
      tryLogin() {
        if (this.user) {
          this.chatForm.user = Object.assign(this.chatForm.user, this.user)
        }

        if (this.customFields && this.customFields instanceof Array) {
          this.chatForm.customFields = this.customFields.reduce((obj, cf) => {
            obj[cf.id] = cf.value
            return obj
          }, {})
        }
      }
    }
  }
</script>

<style>
  .octadesk-content-container {
    padding-top: 1px;
  }

  .octadesk-content-container > p {
    padding-left: 25px !important;
  }

  .octadesk-button {
    font-weight: 500;
  }

  .fields-results-container {
    text-align: center;
  }

  .fields-wrapper {
    height: 100%;
    padding: 0 25px;
    margin-bottom: 10px;
    opacity: 1;
  }

  .octadesk-button__login {
    width: 136px;
    padding: 0.6rem 0.6rem 0.6rem 1rem;
    position: absolute;
    bottom: -16px;
    left: calc(50% - 68px);
  }

  @media screen and (max-device-width: 767px) {
    .octadesk-app-window--bottomRight {
      bottom: 0;
      right: 0;
    }

    .octadesk-app-window--bottomLeft {
      bottom: 0;
      left: 0;
    }

    .octadesk-app-window--topRight {
      top: 0;
      right: 0;
    }

    .octadesk-app-window--topLeft {
      top: 0;
      left: 0;
    }
  }

  @media screen and (min-height: 500px) {
    .form-height-with-agents {
      height: calc(100% - 109px);
    }

    .form-height-without-agents {
      height: calc(100% - 109px);
    }
  }

  .octadesk-app-login {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(253, 253, 253, 1) 8px,
      rgba(246, 246, 246, 1) 100%
    );
    height: 100%;
    max-height: 100%;
    padding-bottom: 70px;
  }

  .octadesk-login--card {
    background: #fff;
    margin: 0 16px;
    padding-bottom: 32px;
    margin-top: -25px;
    position: relative;
  }

  .login--label {
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
  }

  .octadesk-form--input {
    border-radius: 34.5px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px #979797;
    background: #fff;
    color: #757578;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin-bottom: 6px;
  }

  .login-form--title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.04;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
  }

  .login-form--subtitle {
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
    margin: 0 !important;
    margin-bottom: 20px !important;
  }

  .login-form--bold-copy {
    font-family: Roboto;
    font-size: 10px;
    font-weight: bold !important;
    font-stretch: normal;
    font-style: normal;
    line-height: normal !important;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
    margin: 0 !important;
  }
</style>
